import { isElectron } from '@fly/shared';

import { ElectronPlatformService } from './electron-platform-service';
import { IPlatformService } from './platform-service.interface';
import { WebPlatformService } from './web-platform-service';

export class PlatformService {
  private static instance: IPlatformService;

  public static getInstance(): IPlatformService {
    if (!PlatformService.instance) {
      PlatformService.instance = isElectron()
        ? new ElectronPlatformService()
        : new WebPlatformService();
    }
    return PlatformService.instance;
  }
}
